import { Center, Spinner } from "@chakra-ui/react";

export const LoadingSpinner: React.FC = () => (
  <Center>
    <Spinner mt={8} />
  </Center>
);
